import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <footer className="bg-dark text-white py-5">
      <div
        className="position-fixed  end-0 translate-middle-y me-3"
        style={{ zIndex: 10, top: "90%" }}
      >
        <div className="custom-tooltip-wrapper">
          <a
            href="https://wa.me/919600480052"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success rounded-circle shadow"
          >
            <i className="bi bi-whatsapp fs-2 blink"></i>
          </a>
          <span className="custom-tooltip">
            <i className="bi bi-whatsapp me-1"></i> Chat on WhatsApp
          </span>
        </div>
      </div>

      <style>
        {`
    @keyframes blink {
      0%, 50%, 100% {
        opacity: 1;
      }
      25%, 75% {
        opacity: 0;
      }
    }

    .blink {
      animation: blink 2s infinite;
    }

    .custom-tooltip-wrapper {
      position: relative;
      display: inline-block;
    }

    .custom-tooltip {
      visibility: hidden;
      opacity: 0;
      background: linear-gradient(135deg, #25D366, #128C7E);
      color: #fff;
      padding: 8px 12px;
      border-radius: 20px;
      position: absolute;
      right: 70px;
      top: 50%;
      transform: translateY(-50%) translateX(10px);
      white-space: nowrap;
      z-index: 20;
      font-size: 0.85rem;
      font-weight: 500;
      transition: opacity 0.3s ease, transform 0.3s ease;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .custom-tooltip::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-width: 6px;
      border-style: solid;
      border-color: transparent transparent transparent #25D366;
    }

    .custom-tooltip-wrapper:hover .custom-tooltip {
      visibility: visible;
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  `}
      </style>

      <div className="container">
        <div className="row justify-content-center mb-5" data-aos="fade-up">
          <div className="col-lg-10  bg-white p-4 rounded shadow">
            <div className="row align-items-center">
              <div className="col-md-4 mb-3 mb-md-0">
                <h4 className="text-center text-dark mb-0">
                  Join Our Institute Newsletter
                </h4>
              </div>
              <div className="col-md-6 mb-3 mb-md-0">
                <input
                  className="form-control"
                  placeholder="Email"
                  type="email"
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn text-white w-100"
                  style={{ backgroundColor: "#0663ad" }}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Main Sections */}
        <div className="row g-4 g-sm-0">
          <div className="col-lg-3 col-md-5 col-sm-12" data-aos="fade-up">
            <img
              src={require("../Img/images/Logo - New.png")}
              style={{ height: "50px", width: "200px" }}
            ></img>
            <p className="mt-2">
              The proven curriculum and professional practical training shape
              the best IT training institute in Salem.
            </p>
            <div className="social-links mt-1 d-flex justify-content-start">
              <a href="#" className="text-white me-2">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="text-white me-1">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#" className="text-white me-1">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="#" className="text-white">
                <i className="bi bi-instagram"></i>
              </a>
              {/* WhatsApp */}
              <a
                href="https://wa.me/+91 9600480052"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-circle shadow"
                style={{ color: "#ffffff" }}
              >
                <FaWhatsapp size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div
            className=" col-lg-3 col-md-4 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="100"
            style={{ paddingLeft: "50px" }}
          >
            <h4 className=" mb-3" style={{ color: "#008cff" }}>
              Quick Links
            </h4>
            <ul className="list-unstyled">
              <li className="mb-2 ">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/"); // navigate to homepage
                    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top
                  }}
                  className="text-white text-decoration-none"
                >
                  Home
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Aboutus");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  About Us
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Courses
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Placement");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Placements
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Internship");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Internship
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Contactus");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Courses */}
          <div
            className="ms-4 ms-lg-0 ms-md-0 col-lg-2 col-md-3 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h4 className="mb-3" style={{ color: "#008cff" }}>
              Courses
            </h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Cybersecurity
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Data Analytics
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Oracle SQL
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Power BI
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Python
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Software Testing
                </a>
              </li>
              <li className="mb-2">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Courses");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-white text-decoration-none"
                >
                  Tableau
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div
            className="col-lg-4 col-md-12 col-sm-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h4 className=" mb-3" style={{ color: "#008cff" }}>
              Contact Info
            </h4>
            <ul className="list-unstyled">
              <li className="mb-3">
                <i
                  className="bi bi-geo-alt  me-2"
                  style={{ color: "#008cff" }}
                ></i>
                Third Floor, Navanidhi towers, AVR roundana, Junction Main Rd,
                Salem, Tamil Nadu 636005
              </li>
              <li className="mb-3">
                <i
                  className="bi bi-telephone  me-2"
                  style={{ color: "#008cff" }}
                ></i>
                <a
                  href="tel:+919600480052"
                  style={{
                    border: "none",
                    background: "#212529",
                    color: "white",
                    // padding: "8px 16px",
                    display: "inline-block",
                    borderRadius: "4px",
                    textDecoration: "none",
                  }}
                >
                  +91 9600 4800 52
                </a>
              </li>
              <li className="mb-3">
                <i
                  className="bi bi-envelope  me-2"
                  style={{ color: "#008cff" }}
                ></i>
                <a href="mailto:hr@berlintechnovation.com" className="text-decoration-none text-white"> hr@berlintechnovation.com</a>
               
              </li>
              <li>
                <i
                  className="bi bi-clock  me-2"
                  style={{ color: "#008cff" }}
                ></i>
                Mon-Sat: 9AM - 7PM
              </li>
            </ul>
          </div>
        </div>

        <div className="row mt-5 pt-4 border-top border-secondary">
          <div className="col-md-6 text-center text-md-start">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Berlin Technovation. All rights
              reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <a
              href="https://aalantechsoft.com/"
              className="text-white text-decoration-none me-3"
            >
              Developed By Aalan TechSoft
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
